'use client';

import { useState, createContext, useContext } from 'react';
import { getCheckboxChildren } from './helpers';

const useCheckboxer = () => {
  const [checkboxes, setCheckboxes] = useState({});

  const updateCheckboxes = (payload) => {
    if (payload.group) {
      setCheckboxes((checkboxes) => ({
        ...checkboxes,
        [payload.group]: {
          ...checkboxes[payload.group],
          [payload.name]: {
            ...checkboxes[payload.name],
            parent: payload.parent || null,
            checked: payload.checked || false,
            disabled: payload.disabled || false,
            indeterminate: payload.indeterminate || false,
            supportCheckDisabled: payload.supportCheckDisabled || false,
          },
        },
      }));
    } else {
      setCheckboxes((checkboxes) => ({
        ...checkboxes,
        [payload.name]: {
          ...checkboxes[payload.name],
          parent: payload.parent || null,
          checked: payload.checked || false,
          disabled: payload.disabled || false,
          indeterminate: payload.indeterminate || false,
          supportCheckDisabled: payload.supportCheckDisabled || false,
        },
      }));
    }
  };

  /**
   * @deprecated This component is considered very legacy and should not be used.
   * It is recommended to avoid any further use of this component due to its outdated nature.
   * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
   *
   * @param {Object} payload
   * @return {Object}
   */
  const fieldChange = (payload) => {
    updateCheckboxes(payload);
  };

  /**
   * @deprecated This component is considered very legacy and should not be used.
   * It is recommended to avoid any further use of this component due to its outdated nature.
   * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
   *
   * @param {Object} payload
   * @return {Object}
   */
  const registerField = (payload) => {
    updateCheckboxes(payload);
  };

  /**
   * @deprecated This component is considered very legacy and should not be used.
   * It is recommended to avoid any further use of this component due to its outdated nature.
   * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
   *
   * @param {String} name
   * @return {Object}
   */
  const unregisterField = (name) => {
    if (name) {
      setCheckboxes((checkboxes) => {
        let newState = { ...checkboxes };
        delete newState[name];
        return newState;
      });
    }
  };

  return {
    checkboxes,
    fieldChange,
    registerField,
    unregisterField,
    getCheckboxChildren,
  };
};

type CheckboxerContextType = ReturnType<typeof useCheckboxer>;

// @ts-ignore TODO: FIN-32798 strictNullChecks
export const CheckboxerContext = createContext<CheckboxerContextType>(null);

export const useCheckboxerContext = () => {
  const context = useContext(CheckboxerContext);
  if (!context) {
    throw new Error('useCheckboxerContext must be used within a CheckboxerContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const CheckboxerContextProvider = ({ children }: IProps) => (
  <CheckboxerContext.Provider value={ useCheckboxer() }>
    { children }
  </CheckboxerContext.Provider>
);

export default CheckboxerContextProvider;
